<template>
  <!--  <span class="jake-form-tooltip">-->
  <!--  <span class="jake-form-tooltip-inner" data-toggle="tooltip"-->
  <!--        :title="t('tooltips.'+title)">-->
  <!--    i-->
  <!--  </span>-->

  <!--  </span>-->

  <span class="jake-form-tooltip">

  <span class="jake-form-tooltip-inner" data-toggle="tooltip"
        :title="t('tooltips.'+title)">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 0.5C12.1423 0.5 15.5 3.85775 15.5 8C15.5016 9.9691 14.7287 11.8598 13.3482 13.264C11.9677 14.6681 10.0904 15.473 8.12152 15.5049C6.15267 15.5369 4.25025 14.7932 2.825 13.4345C1.39974 12.0758 0.565991 10.2111 0.50375 8.243L0.5 8L0.503 7.79C0.614 3.74525 3.9275 0.5 8 0.5ZM8 7.25H7.25L7.16225 7.25525C6.97996 7.27693 6.81196 7.36472 6.69006 7.50197C6.56816 7.63923 6.50084 7.81643 6.50084 8C6.50084 8.18357 6.56816 8.36077 6.69006 8.49803C6.81196 8.63528 6.97996 8.72307 7.16225 8.74475L7.25 8.75V11L7.25525 11.0878C7.27499 11.2552 7.35056 11.411 7.46976 11.5302C7.58896 11.6494 7.74484 11.725 7.91225 11.7448L8 11.75H8.75L8.83775 11.7448C9.00516 11.725 9.16104 11.6494 9.28024 11.5302C9.39944 11.411 9.47501 11.2552 9.49475 11.0878L9.5 11L9.49475 10.9123C9.47682 10.7592 9.4122 10.6155 9.30968 10.5005C9.20716 10.3855 9.07171 10.3048 8.92175 10.2695L8.83775 10.2545L8.75 10.25V8L8.74475 7.91225C8.72501 7.74484 8.64944 7.58896 8.53024 7.46976C8.41104 7.35056 8.25516 7.27499 8.08775 7.25525L8 7.25ZM8.0075 5L7.91225 5.00525C7.72996 5.02693 7.56196 5.11472 7.44006 5.25197C7.31816 5.38923 7.25084 5.56643 7.25084 5.75C7.25084 5.93357 7.31816 6.11077 7.44006 6.24803C7.56196 6.38528 7.72996 6.47307 7.91225 6.49475L8 6.5L8.09525 6.49475C8.27754 6.47307 8.44554 6.38528 8.56744 6.24803C8.68934 6.11077 8.75666 5.93357 8.75666 5.75C8.75666 5.56643 8.68934 5.38923 8.56744 5.25197C8.44554 5.11472 8.27754 5.02693 8.09525 5.00525L8.0075 5Z"
            fill="#8A8A8A"/>
    </svg>
  </span>

  </span>

</template>

<script>
import {useI18n} from "vue-i18n";
import {ref} from 'vue'

export default {
  name: "Tooltip",
  props: ['title'],
  setup() {
    const {t} = useI18n({useScope: 'global'})
    const select = ref(0)
    return {t, select}
  },
  data() {
    return {
      tranTitle: ''
    }
  },

  mounted() {
    if (window.jQuery && typeof $.fn.tooltip === 'function') {
      $('[data-toggle="tooltip"]').tooltip();
    }
  },
}
</script>

<style lang="scss" scoped>
.jake-form-tooltip {
  display: inline-block;
  position: relative;

  .jake-form-tooltip-inner {
    position: absolute;
    top: -16px;
    right: -15px;
    width: 12px;
    display: block;
    text-align: center;
    height: 12px;
    color: #8A8A8A;
    //border: 1px solid #8A8A8A;
    font-size: 8px;
    line-height: 10px;
    font-weight: bold;
    border-radius: 100%;
    cursor: default;

    @media #{$sm} {
      width: 15px;
      height: 15px;
      top: -14px;
      right: -18px;
      font-size: 11px;
      line-height: 12px;
    }
    @media #{$xs} {
      width: 15px;
      height: 15px;
      top: -14px;
      right: -20px;
      font-size: 11px;
      line-height: 12px;
    }

    &:hover {
      color: #ef4956;
      border-color: #ef4956;

    }


  }
}
</style>


<!--<style lang="scss" scoped>-->
<!--.jake-form-tooltip {-->
<!--  display: inline-block;-->
<!--  position: relative;-->

<!--  .jake-form-tooltip-inner {-->
<!--    position: absolute;-->
<!--    top: -16px;-->
<!--    right: -15px;-->
<!--    width: 12px;-->
<!--    display: block;-->
<!--    text-align: center;-->
<!--    height: 12px;-->
<!--    color: #8A8A8A;-->
<!--    border: 1px solid #8A8A8A;-->
<!--    font-size: 8px;-->
<!--    line-height: 10px;-->
<!--    font-weight: bold;-->
<!--    border-radius: 100%;-->
<!--    cursor: default;-->

<!--    @media #{$sm} {-->
<!--      width: 15px;-->
<!--      height: 15px;-->
<!--      top: -14px;-->
<!--      right: -18px;-->
<!--      font-size: 11px;-->
<!--      line-height: 12px;-->
<!--    }-->
<!--    @media #{$xs} {-->
<!--      width: 15px;-->
<!--      height: 15px;-->
<!--      top: -14px;-->
<!--      right: -20px;-->
<!--      font-size: 11px;-->
<!--      line-height: 12px;-->
<!--    }-->

<!--    &:hover {-->
<!--      color: #ef4956;-->
<!--      border-color: #ef4956;-->

<!--    }-->


<!--  }-->
<!--}-->
<!--</style>-->
